import { render, staticRenderFns } from "./QnAScreen.vue?vue&type=template&id=3cc56e7e"
import script from "./QnAScreen.vue?vue&type=script&lang=js"
export * from "./QnAScreen.vue?vue&type=script&lang=js"
import style0 from "./QnAScreen.vue?vue&type=style&index=0&id=3cc56e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports